import { z, isoZ } from 'my-zod'
import { LifecycleStatuses, vehicleLifecycleStatusEnum } from '../vehicle/vehicles-model'

export const vehicleDispositionV2StatusEnum = z.enum([
  'AwaitingForm',
  'Approved',
  'Rejected',
  'ReadyForPolarisReview',
  'PickupScheduled',
  'Complete'
])
export const DispositionV2Statuses = vehicleDispositionV2StatusEnum.Values
export type DispositionV2Status = z.infer<typeof vehicleDispositionV2StatusEnum>

export const dispositionStatusesMap = [
  {
    value: DispositionV2Statuses.AwaitingForm,
    label: 'Awaiting Photos & Notes'
  },
  {
    value: DispositionV2Statuses.Approved,
    label: 'Disposition Approved'
  },
  {
    value: DispositionV2Statuses.Complete,
    label: 'Disposition Complete'
  },
  {
    value: DispositionV2Statuses.PickupScheduled,
    label: 'Pickup Scheduled'
  },
  {
    value: DispositionV2Statuses.ReadyForPolarisReview,
    label: 'Disposition Review-Ready'
  },
  {
    value: DispositionV2Statuses.Rejected,
    label: 'Disposition Rejected'
  }
]

export const vehicleToVehicleDispositionStatusesDependency = {
  [DispositionV2Statuses.AwaitingForm]: LifecycleStatuses.InactiveReadyForDisposition,
  [DispositionV2Statuses.Rejected]: LifecycleStatuses.InactiveReadyForDisposition,
  [DispositionV2Statuses.ReadyForPolarisReview]: LifecycleStatuses.InactiveDispositionReadyForReview,
  [DispositionV2Statuses.Approved]: LifecycleStatuses.DispositionApprovedReadyForPickup,
  [DispositionV2Statuses.PickupScheduled]: LifecycleStatuses.InactivePickupScheduled,
  [DispositionV2Statuses.Complete]: LifecycleStatuses.SalePending
}

export const vehicleToVehicleDispositionSubStatusesDependency = {
  [DispositionV2Statuses.ReadyForPolarisReview]: 'Account Manager',
  [DispositionV2Statuses.Rejected]: 'Rejected',
  [DispositionV2Statuses.Complete]: 'Submitted to Sales Ops'
}

export const vehicleDispositionPreCheckAnswers = z.object({
  vinMatch: z.boolean(),
  repairsCompleted: z.enum(['yes', 'noWithPermission', 'noWithoutPermission']),
  trackLugs: z.boolean().or(z.null()),
  serialNumberMatch: z.boolean().or(z.null()),
  vehicleStart: z.boolean()
})
export type vehicleDispositionPreCheckAnswers = z.infer<typeof vehicleDispositionPreCheckAnswers>

export const vehicleDispositionsV2Model = z.object({
  id: z.string().uuid(),
  shortId: z.string(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  vehicleId: z.number(),
  operatorId: z.number(),
  notes: z.string(),
  vehicleImageRight: z.string().array(),
  vehicleImageLeft: z.string().array(),
  vehicleImageFront: z.string().array(),
  vehicleImageBack: z.string().array(),
  vehicleClusterMilesImage: z.string().array(),
  vehicleClusterHoursImage: z.string().array(),
  vehicleHinImage: z.string().array(),
  vehicleSerialNumberImage: z.string().array(),
  vehicleEngineLowerImage: z.string().array(),
  vehicleEngineUpperImage: z.string().array(),
  vehicleTubesImage: z.string().array(),
  vehicleFrontSeatingImage: z.string().array(),
  vehicleRearSeatingImage: z.string().array(),
  vehicleBiminiCoverImage: z.string().array(),
  additionalVehicleImages: z.string().array().max(20),
  reviewNotes: z.string(),
  status: vehicleDispositionV2StatusEnum,
  outfitterIndicatesPolarisApprovedWithoutRepairs: z.boolean(),
  startingVehicleLifecycleStatus: vehicleLifecycleStatusEnum.nullable()
})

export type vehicleDispositionsV2Model = z.infer<typeof vehicleDispositionsV2Model>
